<template>
  <b-navbar type="dark" variant="transparent">
    <b-navbar-brand to="/">
      <NvLogo style="height:30px"/>
      Azure DevOps Toolkit
    </b-navbar-brand>
    <b-navbar-nav>
      <b-nav-item to="/report-generator">Report Generator</b-nav-item>
      <b-nav-item to="/release-note-generator">Release Note Generator</b-nav-item>
      <b-collapse>
        <b-nav-item to="/create">Project Creator</b-nav-item>
      </b-collapse>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-nav-text v-if="account">
        <b-icon-person-fill/>
        {{ account.name }}
      </b-nav-text>
      <!-- <b-nav-item v-if="!account" @click="SignIn">Log In</b-nav-item> -->
      <b-nav-item v-if="account" @click="SignOut">Log Out</b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { mapStores } from 'pinia';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '@/settings';
import useApiStore from '@/stores/api';
import NvLogo from './UI/NvLogo.vue';

export default {
  name: 'Header',
  data() {
    return {
      account: null,
      msalInstance: null,
    };
  },
  components: {
    NvLogo,
  },
  async created() {
    this.msalInstance = new PublicClientApplication(
      msalConfig,
    );
    this.account = this.msalInstance.getActiveAccount();
  },
  computed: {
    ...mapStores(useApiStore),
  },
  methods: {
    async SignOut() {
      await this.msalInstance
        .logoutPopup({})
        .then(() => {
          this.account = null;
          this.webApiToken = null;
          toast.success('You have been logged out successfully.');
          this.$router.push('/');
        })
        .catch(() => {
          toast.error('An error occurred while logging out.');
        });
    },
  },
};
</script>

<style scoped></style>
